(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unico-cookie-settings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('unico-cookie-settings')) {
    customElements.define('unico-cookie-settings', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.querySelector('button').addEventListener('click', async () => {
          const status = this.querySelector('[role="status"]');
          status.hidden = true;
          try {
            for (let attempt = 0; !window.privacyBanner?.showPreferences && attempt < 20; attempt++) {
              await new Promise(resolve => setTimeout(resolve, 100));
            }
            if (!window.privacyBanner?.showPreferences) throw new Error('Preferences unavailable');
            await window.privacyBanner.showPreferences();
          } catch {
            status.hidden = false;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["unico-photo-compare"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('unico-photo-examples')) {
    customElements.define('unico-photo-examples', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const buttons = [...this.querySelectorAll('[data-example-button]')];
        const panels = [...this.querySelectorAll('[data-example-panel]')];
        buttons.forEach(button => button.addEventListener('click', () => {
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          panels.forEach(panel => {
            panel.hidden = panel.dataset.examplePanel !== button.dataset.exampleButton;
            const range = panel.querySelector('input[type="range"]');
            range.value = '50';
            panel.style.setProperty('--reveal', '50%');
          });
        }));
      }
    });
  }

  if (!customElements.get('unico-photo-compare')) {
    customElements.define('unico-photo-compare', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const range = this.querySelector('input[type="range"]');
        const update = () => this.style.setProperty('--reveal', range.value + '%');
        range.addEventListener('input', update);
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
